import React from 'react';

import MoneBackImage from 'assets/money_back.svg';

import Visa from 'assets/livenicons/visa.svg';
import Amex from 'assets/livenicons/amex.svg';
import PayPal from 'assets/livenicons/paypal.svg';
import ApplePay from 'assets/livenicons/applepay.svg';
import Maestro from 'assets/livenicons/maestro.svg';
import Mastercard from 'assets/livenicons/mastercard.svg';

import styles from './styles.module.scss';
import Divider from 'components/divider/Divider';

export const MoneyGuarantee = () => {
  return (
    <div className={styles.checkoutMoneyback}>
      <div className={styles.checkoutMoneybackBox}>
        <div className={styles.header}>
          <div className={styles.seal}>
            <img src={MoneBackImage} alt="" />
          </div>
          <h5>
            30-Day Money-
            <br />
            Back <span className={styles.accent}>Guarantee</span>
          </h5>
        </div>

        <p>
          Your success is our priority. If you're not completely sotiesfied with
          your results,{' '}
          <span className={styles.bold}>
            simply let us know within 30 days from when you were charged, and
            we'll provide a full refund - no question asked.
          </span>{' '}
          For more details see your{' '}
          <a className={styles.accent} href="https://loona.app/terms.html">
            Terms of Use
          </a>
        </p>
      </div>

      <Divider isDividerWithNoMargin />

      <p className={styles.paymentsBrandLabel}>Guaranteed safe checkout</p>
      <div className={styles.paymentsBrand}>
        <img src={ApplePay} alt="" />
        <img src={PayPal} alt="" />
        <img src={Visa} alt="" />
        <img src={Mastercard} alt="" />
        <img src={Maestro} alt="" />
        <img src={Amex} alt="" />
      </div>
    </div>
  );
};
